import { render, staticRenderFns } from "./adc.vue?vue&type=template&id=19380b4b&scoped=true"
import script from "./adc.vue?vue&type=script&lang=js"
export * from "./adc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19380b4b",
  null
  
)

export default component.exports